import React from 'react';
import {Link} from "react-router-dom";
import MobileMenu from './MobileMenu';

const Nav = () => {
    return (

        <>
            <div class="main-menu__inner">
                <MobileMenu />
                <ul class="main-menu__list">
                    <li><Link to={`/`}>Home</Link></li>
                    <li><Link to={`/about`}>About</Link></li>
                    <li><Link to={`/contact`}>Contact</Link></li>
					<li><Link to={`/term`}>Term & Condition</Link></li>
                </ul>
            </div>
        </>
    )
}

export default Nav;


